import type { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import TextButton from '@/components/@IntranetLibrary/Button/TextButton';
import {
  formatContractDate,
  formatContractText,
  toContractHref,
} from '@/components/Approval/@components/ContractInfo';
import ContractStatusBadge from '@/components/Approval/LinkBlock/ContractStatusBadge';
import ChevronRightIcon from '@/public/icons/approval/chevron-right.svg';
import type { ElawContract } from '@/types/approval';
import {
  ContractOptionMeta,
  ContractOptionName,
  ContractOptionRoot,
} from './styles';

type ContractOptionProps = {
  contract: ElawContract;
  fallbackName: string;
};

// 메뉴 항목 클릭이 선택+닫기로 이어지지 않게 끊음
const stopSelect = (e: MouseEvent) => e.stopPropagation();

/** 계약 선택 목록 한 줄 — 레거시 드롭다운과 같은 구성(상태·계약명·기안자·계약상대·시작일·상세보기) */
const ContractOption = ({ contract, fallbackName }: ContractOptionProps) => {
  const { t } = useTranslation();
  const href = toContractHref(contract.accessLink);
  return (
    <ContractOptionRoot>
      {contract.status && (
        <ContractStatusBadge
          status={contract.status}
          fallbackLabel={contract.statusName ?? undefined}
        />
      )}
      <ContractOptionName>
        {contract.contractName?.trim() || fallbackName}
      </ContractOptionName>
      <ContractOptionMeta>
        <span>
          {t('기안자')}: {formatContractText(contract.creatorInfo)}
        </span>
        <span>
          {t('계약상대')}: {formatContractText(contract.opponentInfo)}
        </span>
        <span>
          {t('시작일')}: {formatContractDate(contract.startDate)}
        </span>
      </ContractOptionMeta>
      {href && (
        <TextButton
          type="button"
          size="small"
          endIcon={<ChevronRightIcon />}
          onMouseDown={stopSelect}
          onClick={(e) => {
            stopSelect(e);
            window.open(href, '_blank', 'noopener,noreferrer');
          }}
        >
          {t('상세보기')}
        </TextButton>
      )}
    </ContractOptionRoot>
  );
};

export default ContractOption;
